import {
    IS_LOADING, RECEIVE_CARTWORKS_LIST_CART
} from "../actions/cartActions";
export const initState = {
    loading: false,
    artworkList:{},
}
const cartModulereducer = (state = initState, action) => {
    switch (action.type) {
        case IS_LOADING: {
            return {
                ...state,
                loading: false,
                navCategories: action.payload,
            }
        }
        case RECEIVE_CARTWORKS_LIST_CART: {
            return {
                ...state,
                loading: false,
                artworkList: action.payload,
            }
        }

        default:
            return state;
    }
}
export default cartModulereducer;